import React from 'react';

import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';

import styles from './InitialStep.module.scss';

interface StartKbaPageProps {
  onStart: () => void;
  borrowerName?: string | null;
}

const InitialStep = ({ onStart, borrowerName }: StartKbaPageProps) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{borrowerName}'s Identity Verification Questions</p>
      <p className={styles.text}>Complete the following identity verification steps.</p>
      <p className={styles.text}>
        Failure to complete this within the next 24 hours will result in the cancelation of your loan inquiry.
      </p>
      <p className={styles.text}>Once started you will have 5 minutes to complete.</p>
      <Button className={styles.button} buttonType={ButtonType.Primary} onClick={onStart}>
        Start
      </Button>
    </div>
  );
};

export default InitialStep;
